import React from 'react';

import { useTranslation } from 'react-i18next';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import { useGetUserSubscriptions } from '../../../services/redux/api/usersApi';
import withRouter from '../../../hooks/with-router';
import UsersList from '../../../components/reusable/users-list/UsersList';
import { useNotFound } from '../../../hooks/useNotFound';
import { useStyles } from './UserSubscriptions.styles';
import theme from '../../../styles/theme';

function UserSubscriptions(props) {
  const { params } = props;
  const { t, i18n } = useTranslation();
  const { data: subscriptions, isFetching } = useGetUserSubscriptions(
    params.userId,
  );
  useNotFound(!isFetching && !subscriptions);
  const { classes } = useStyles(theme);

  return (
    <PageContainer title={t('user.subscriptions')} backButton>
      <div className={classes.subscriptionsWrapper}>
        <UsersList users={subscriptions} />
      </div>
    </PageContainer>
  );
}

export default withRouter(UserSubscriptions);
